import { sum } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
// @mui
import {Box, Stack, Button, Divider, MenuItem, Typography, inputBaseClasses, InputAdornment} from '@mui/material';
// utils
import { fCurrency } from '../../../../util/format-number.js';


// components
import Iconify from '../../../../components/iconify/index.js';
import { RHFSelect, RHFTextField,  } from '../../../../components/hook-form/index.js';

// ----------------------------------------------------------------------

import { GET_ALL_SUBSCRIPTION } from "../../../../graphql/modules/subscription.js";
import { useQuery } from "@apollo/react-hooks";


const SUBSCRIPTION_DATA = [
    {id: 'basic', name: 'Basic', price: 100},
    {id: 'standard', name: 'Standard', price: 150},
    {id: 'premium', name: 'Premium', price: 200},
    {id: 'customized', name: 'Customized', price: 250}
]


// ----------------------------------------------------------------------

export default function InvoiceNewEditDetails() {
  const { control, setValue, watch, resetField } = useFormContext();
  const [results, setResults] = useState(null);
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const { data, loading, error, refetch } = useQuery(GET_ALL_SUBSCRIPTION, {
    variables: {
      limit: 10,
      offset: 0,
      searchText: "",
      companyName: "iatos",
      order: "asc",
      orderBy: "_id"
      },
      fetchPolicy: "cache-and-network",
    });

  const values = watch();

  const totalOnRow = values?.items?.map((item) => item?.quantity * item?.price);
   
  const subTotalless = sum(totalOnRow);
  const subTotal = (subTotalless - values?.totalGrants - values.discount);


  const mappedNumbers = sum(values?.items?.map(num => num?.price < 0 ? Math.abs(num?.quantity * num?.price) : 0));
  const tax = (subTotalless + mappedNumbers - values.discount) * (values.taxes / 100); 
  
  const totalAmount = parseFloat(subTotal.toFixed(2)) + parseFloat(tax.toFixed(2));
  
  useEffect(() => {
    setValue('totalAmount', totalAmount);
  }, [setValue, totalAmount]);

  useEffect(() => {
    if(data){
      setResults(data?.getAllSubscription)
    }
}, [data])

  const handleAdd = () => {
    append({
      title: '',
      description: '',
      service: '',
      quantity: 1,
      price: 0,
      total: 0,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  const handleClearService = useCallback(
    (index) => {
      resetField(`items[${index}].quantity`);
      resetField(`items[${index}].price`);
      resetField(`items[${index}].total`);
    },
    [resetField]
  );

  const handleSelectService = useCallback(
    (index, option, amount) => {
      console.log(amount)
      setValue(
        `items[${index}].price`,
        amount
      );
      setValue(
        `items[${index}].total`,
        values.items.map((item) => item.quantity * item.price)[index]
      );
    },
    [setValue, values.items]
  );

  const handleChangeQuantity = useCallback(
    (event, index) => {
      setValue(`items[${index}].quantity`, Number(event.target.value));
      setValue(
        `items[${index}].total`,
        values.items.map((item) => item.quantity * item.price)[index]
      );
    },
    [setValue, values.items]
  );

  const handleChangePrice = useCallback(
    (event, index) => {
      setValue(`items[${index}].price`, Number(event.target.value));
      setValue(
        `items[${index}].total`,
        values.items.map((item) => item.quantity * item.price)[index]
      );
    },
    [setValue, values.items]
  );

  const renderTotal = (
    <Stack
      spacing={2}
      alignItems="flex-end"
      sx={{ mt: 3, textAlign: 'right', typography: 'body2' }}
    >
            <Stack direction="row">
        <Box sx={{ color: 'text.secondary' }}>Grants</Box>
        <Box
          sx={{
            width: 160,
            ...(values?.totalGrants && { color: 'error.main' }),
          }}
        >
          {values.totalGrants ? `- ${fCurrency(values?.totalGrants)}` : '-'}
        </Box>
      </Stack>

      <Stack direction="row">
        <Box sx={{ color: 'text.secondary' }}>Discount</Box>
        <Box
          sx={{
            width: 160,
            ...(values.discount && { color: 'error.main' }),
          }}
        >
          {values.discount ? `- ${fCurrency(values.discount)}` : '-'}
        </Box>
      </Stack>  

      <Stack direction="row">
        <Box sx={{ color: 'text.secondary' }}>Subtotal</Box>
        <Box sx={{ width: 160, typography: 'subtitle2' }}>{fCurrency(subTotal) || '-'}</Box>
      </Stack>

      <Stack direction="row">
        <Box sx={{ color: 'text.secondary' }}>Taxes</Box>
        <Box sx={{ width: 160 }}>{tax? fCurrency(tax) : '-'}</Box>
      </Stack>

      <Stack direction="row" sx={{ typography: 'subtitle1' }}>
        <Box>Total</Box>
        <Box sx={{ width: 160 }}>{fCurrency(totalAmount) || '-'}</Box>
      </Stack>
    </Stack>
  );


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
        Details:
      </Typography>

      <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => {
          return (
          <Stack key={item.id} alignItems="flex-end" spacing={1.5}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ width: 1 }}>

              
              <RHFTextField
                name={`items[${index}].description`}
                label="Description"
                InputLabelProps={{ shrink: true }}
              />

              {/* <RHFSelect
                name={`items[${index}].service`}
                size="small"
                label="Service"
                InputLabelProps={{ shrink: true }}
                sx={{
                  maxWidth: { md: 160 },
                }}
              >
                <MenuItem
                  value=""
                  onClick={() => handleClearService(index)}
                  sx={{ fontStyle: 'italic', color: 'text.secondary' }}
                >
                  None
                </MenuItem>

                <Divider sx={{ borderStyle: 'dashed' }} />

                {results?.results?.map((service) => (
                  <MenuItem
                    key={service._id}
                    value={service.title}
                    onClick={() => handleSelectService(index, service.title, service.amount)}
                  >
                    {service.title}
                  </MenuItem>
                ))}
              </RHFSelect> */}

              <RHFTextField
                type="number"
                name={`items[${index}].quantity`}
                label="Quantity"
                placeholder="0"
                onChange={(event) => handleChangeQuantity(event, index)}
                InputLabelProps={{ shrink: true }}
                sx={{ maxWidth: { md: 96 } }}
                disabled
                
              />

              <RHFTextField
                type="number"
                name={`items[${index}].price`}
                label="Price"
                placeholder="0.00"
                onChange={(event) => handleChangePrice(event, index)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: { md: 180 } }}
              />

              <RHFTextField
                disabled
                type="number"
                name={`items[${index}].total`}
                label="Total"
                placeholder="0.00"
               
                value={ values?.items ? values?.items[index]?.total?.toFixed(2) : ''}
                onChange={(event) => handleChangePrice(event, index)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  maxWidth: { md: 180 },
                  [`& .${inputBaseClasses.input}`]: {
                    textAlign: { md: 'right' },
                  },
                }}
              />
            </Stack>

            <Button
              size="small"
              color="error"
              startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
              onClick={() => handleRemove(index)}
            >
              Remove
            </Button>
          </Stack>
        )})}
      </Stack>

      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />
      <Stack
        spacing={3}
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-end', md: 'center' }}
      >
          <Stack
              spacing={2}
              justifyContent="flex-start"
              direction={{ xs: 'column', md: 'column' }}
              sx={{ width: 1 }}
            >
              
                <Typography variant='body1'>{`Course: ${values?.courseInfo?.courseTitle ? values?.courseInfo?.courseTitle : ''}`}</Typography>
                <Typography variant='body1'>{`Reference Number: ${values?.courseInfo?.tsgRefNumber ? values?.courseInfo?.tsgRefNumber : ''}`}</Typography>
                <Typography variant='body1'>{`Course Date: ${values?.courseInfo?.courseStart ? values?.courseInfo?.courseStart  + ' - ' + values?.courseInfo?.courseEnd : ''}`}</Typography>
                  {
                     values?.grantDetails ?
                      <>
                         {values?.grantDetails?.eligibleGrants?.map((res) => {
                            return (
                              <Typography variant='body1'>{`Less ${res?.schemeName}`}</Typography>
                            )
                        })}
                      </>
                     :
                     ''
                  }
          </Stack>
        </Stack>


      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />

      <Stack
        spacing={3}
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-end', md: 'center' }}
      >
        <Button
          size="small"
          color="primary"
          startIcon={<Iconify icon="mingcute:add-line" />}
          onClick={handleAdd}
          sx={{ flexShrink: 0 }}
        >
          Add Item
        </Button>

        <Stack
          spacing={2}
          justifyContent="flex-end"
          direction={{ xs: 'column', md: 'row' }}
          sx={{ width: 1 }}
        >
        
        <RHFTextField
            size="small"
            label="Grants ($)"
            name="totalGrants"
            type="number"
            sx={{ maxWidth: { md: 120 } }}
          />


          <RHFTextField
            size="small"
            label="Discount($)"
            name="discount"
            type="number"
            sx={{ maxWidth: { md: 120 } }}
          />

          <RHFTextField
            size="small"
            label="GST (%)"
            name="taxes"
            type="number"
            sx={{ maxWidth: { md: 120 } }}
          />
        </Stack>
      </Stack>

      {renderTotal}
    </Box>
  );
}
